import {
  FETCHING_SKILLS_FAILED,
  FETCHING_SKILLS_REQUEST,
  FETCHING_SKILLS_SUCCEEDED,
  INVALIDATE_SKILLS,
  SEARCHING_SKILLS_FAILED,
  SEARCHING_SKILLS_REQUEST,
  SEARCHING_SKILLS_SUCCEEDED,
} from "src/redux/actions/actionTypes";
import _ from "lodash";
import { UpdateSkillPreference } from "src/types/coaching/courses";

interface SkillsState {
  loading: boolean;
  loaded: boolean;
  items: any[];
  searchResults: any[];
  pagination: {
    currentPage: number;
    totalPages: number;
    recordsPerPage: number;
    totalRecordsCount: number;
    hasMoreItems: boolean;
  };
  error: any;
}

const initialState: SkillsState = {
  loading: false,
  loaded: false,
  items: [],
  searchResults: [],
  pagination: {
    currentPage: 0,
    totalPages: 0,
    recordsPerPage: 0,
    totalRecordsCount: 0,
    hasMoreItems: false,
  },
  error: null,
};

export function skillsReducer(state = initialState, action: any) {
  switch (action.type) {

    case FETCHING_SKILLS_REQUEST: {

      return {
        ...state,
        loading: true,
        loaded: false,
        error: null,
      };
    }

    case FETCHING_SKILLS_SUCCEEDED: {

      const { response } = action.payload as any;
      const existingItems = state.items || [];

      let records = response.records;
      if (response.currentPage > 0) {
        records = [...existingItems, ...records];
      }

      records = _.uniqBy(records, "id");

      return {
        ...state,
        loading: false,
        loaded: true,
        items: records,
        pagination: {
          currentPage: response.currentPage,
          totalPages: response.totalPages,
          recordsPerPage: response.recordsPerPage,
          totalRecordsCount: response.totalRecordsCount,
          hasMoreItems: response.currentPage < response.totalPages - 1,
        },
        error: null,
      };
    }

    case FETCHING_SKILLS_FAILED: {

      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.payload.error,
      };
    }

    case SEARCHING_SKILLS_REQUEST: {
      
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null,
      };
    }

    case SEARCHING_SKILLS_SUCCEEDED: {
      
      const { response } = action.payload as any;
      const existingItems = state.items || [];

      let records = response.records;
      if (response.currentPage > 0) {
        records = [...existingItems, ...records];
      }

      records = _.uniqBy(records, "id");

      return {
        ...state,
        loading: false,
        loaded: true,
        searchResults: records,
        pagination: {
          currentPage: response.currentPage,
          totalPages: response.totalPages,
          recordsPerPage: response.recordsPerPage,
          totalRecordsCount: response.totalRecordsCount,
          hasMoreItems: response.currentPage < response.totalPages - 1,
        },
        error: null
      }
    }

    case SEARCHING_SKILLS_FAILED: {
      
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.payload.error,
      }
    }

    case INVALIDATE_SKILLS: {
      return {
        ...state,
        loading: false,
        loaded: false,
        items: [],
        searchResults: [],
        pagination: {
          currentPage: 0,
          totalPages: 0,
          recordsPerPage: 0,
          totalRecordsCount: 0,
          hasMoreItems: false,
        },
        error: null,
      };
    }

    default:
      return state;
  }
}
